module.exports = __webpack_public_path__ + "img/60664828000176.04d709ed.png";